import React from 'react';
import { Link } from 'react-router-dom';
import { Search, MessageSquare, Vote, ArrowRight } from 'lucide-react';

export default function ReaderLanding() {
  return (
    <div className="space-y-16 pb-8">
      <section className="text-center space-y-6 py-12">
        <h1 className="text-6xl font-bold" 
            style={{ 
              background: `linear-gradient(135deg, var(--color-accent1), var(--color-accent2))`,
              WebkitBackgroundClip: 'text'
            }}>
          Discover Tomorrow's Stories Today
        </h1>
        <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--color-accent2)' }}>
          Be part of the journey from concept to completion. Help shape the stories you want to read.
        </p>
        <div className="flex justify-center gap-4">
          <Link
            to="/auth?mode=signup&role=reader"
            className="px-6 py-3 rounded-lg hover:opacity-80 font-medium"
            style={{ 
              backgroundColor: 'var(--color-accent1)',
              color: 'var(--color-background)'
            }}
          >
            Join as Reader
          </Link>
          <Link
            to="/auth"
            className="px-6 py-3 rounded-lg hover:opacity-80 border font-medium"
            style={{ 
              borderColor: 'var(--color-accent1)',
              color: 'var(--color-accent1)'
            }}
          >
            Sign In
          </Link>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4">
        <div className="rounded-2xl p-8 md:p-12" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
          <h2 className="text-3xl font-bold mb-6" style={{ color: 'var(--color-font)' }}>Why Join as a Reader?</h2>
          <p className="text-lg mb-8" style={{ color: 'var(--color-font)' }}>
            StoryMuse.io gives you unprecedented access to stories in their earliest stages. Your feedback and 
            engagement help shape these ideas into the books you'll love to read.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: 'var(--color-background)' }}>
              <Search className="w-8 h-8 mb-4" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg mb-2" style={{ color: 'var(--color-font)' }}>Early Access</h3>
              <p style={{ color: 'var(--color-font)' }}>
                Discover exciting new stories before they're written and follow their development.
              </p>
            </div>
            <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: 'var(--color-background)' }}>
              <Vote className="w-8 h-8 mb-4" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg mb-2" style={{ color: 'var(--color-font)' }}>Have Your Say</h3>
              <p style={{ color: 'var(--color-font)' }}>
                Vote on story elements and help authors make key decisions about their books.
              </p>
            </div>
            <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: 'var(--color-background)' }}>
              <MessageSquare className="w-8 h-8 mb-4" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg mb-2" style={{ color: 'var(--color-font)' }}>Connect with Authors</h3>
              <p style={{ color: 'var(--color-font)' }}>
                Engage directly with authors and become part of their creative journey.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4">
        <div className="rounded-2xl p-8 md:p-12 text-center" style={{ backgroundColor: 'var(--color-accent1)' }}>
          <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--color-background)' }}>
            Ready to Start Reading?
          </h2>
          <p className="text-lg mb-8" style={{ color: 'var(--color-background)', opacity: 0.9 }}>
            Join StoryMuse.io today and become part of the next great story.
          </p>
          <Link
            to="/auth?mode=signup&role=reader"
            className="inline-flex items-center px-6 py-3 rounded-lg hover:opacity-80 font-medium"
            style={{ 
              backgroundColor: 'var(--color-background)',
              color: 'var(--color-accent1)'
            }}
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
}